export default "__VITE_ASSET__dhuvH3Oy__"